/* eslint-disable */
export const data = {
	title: '¿Cual es tu versión de Strada?',
	titleMobile: 'Conheça todas<br>versões da<br>FIAT Strada',
	description: 'Conheça outras versões do Fiat Strada.',
	garantia: '/assets/images/desktop/360/nav/img_3anos.png',
	help: 'Arraste',
	helpLoad: 'Activar 360',
	switchTitle: 'Já está apaixonado pelo Strada?',
	versions: [
					//RANCH	
					[
						{
							doubleCabin: true,
							mobile:
							{
								name: 'RANCH',
								fullname: 'FIAT STRADA RANCH',
								icon: '/assets/images/desktop/360/nav/ranch.png',
								dirname: '/assets/images/mobile/360/RANCH/',
								ext: '.jpg',
								details:
								[
									'Central multimedia Uconnect de 7” que espeja tu teléfono',
									'Faros LED',
									'Cámara y sensores traseros de estacionamiento',
								],
							},
							desktop:
							{
								name: 'RANCH',
								fullname: 'FIAT STRADA RANCH',
								icon: '/assets/images/desktop/360/nav/ranch.png',
								dirname: '/assets/images/desktop/360/RANCH/',
								ext: '.jpg',
								details:
								[
									'Central multimedia Uconnect de 7” que espeja tu teléfono',
									'Faros LED',
									'Cámara y sensores traseros de estacionamiento',
								],
							},
						},
					],
		// ENDURANCE
		[
			{
				doubleCabin: false,
				mobile:
				{
					name: 'ENDURANCE',
					fullname: 'FIAT STRADA ENDURANCE',
					icon: '/assets/images/desktop/360/nav/endurance-simples.png',
					dirname: '/assets/images/mobile/360/ENDURANCE-SIMPLES/',
					ext: '.jpg',
					details:
					[
						'Control de estabilidad con asistencia al arranque en pendiente',
						'Control de traccion avanzado con E-Locker (TC+)',
						'Radio AM/FM con Wireless Connectivity y comandos de audio al volante<br/> <small></small>',
					],
				},
				desktop:
				{
					name: 'ENDURANCE',
					fullname: 'FIAT STRADA ENDURANCE',
					icon: '/assets/images/desktop/360/nav/endurance-simples.png',
					dirname: '/assets/images/desktop/360/ENDURANCE-SIMPLES/',
					ext: '.jpg',
					details:
					[
						'Control de estabilidad con asistencia al arranque en pendiente',
						'Control de traccion avanzado con E-Locker (TC+)',
						'Radio AM/FM con Wireless Connectivity y comandos de audio al volante<br/> <small></small>',

					],
				},
			},
			{
				doubleCabin: true,
				mobile:
				{
					name: 'ENDURANCE',
					fullname: 'FIAT STRADA ENDURANCE',
					icon: '/assets/images/desktop/360/nav/endurance-dupla.png',
					dirname: '/assets/images/mobile/360/ENDURANCE-DUPLA/',
					ext: '.jpg',
					details:
					[
						'Control de estabilidad con asistencia al arranque en pendiente',
						'Control de traccion avanzado con E-Locker (TC+)',
						'Radio AM/FM con Wireless Connectivity y comandos de audio al volante<br/> <small></small>',
					],
				},
				
				desktop:
				{
					name: 'ENDURANCE',
					fullname: 'FIAT STRADA ENDURANCE',
					icon: '/assets/images/desktop/360/nav/endurance-dupla.png',
					dirname: '/assets/images/desktop/360/ENDURANCE-DUPLA/',
					ext: '.jpg',
					details:
					[
						'Control de estabilidad con asistencia al arranque en pendiente',
						'Control de traccion avanzado con E-Locker (TC+)',
						'Radio AM/FM con Wireless Connectivity y comandos de audio al volante<br/> <small></small>',
					],
				},
			},

		],
		// FREEDOM
		[
			{
				doubleCabin: true,
				mobile:
				{
					name: 'FREEDOM',
					fullname: 'FIAT STRADA FREEDOM',
					icon: '/assets/images/desktop/360/nav/freedom-dupla.png',
					dirname: '/assets/images/mobile/360/FREEDOM-DUPLA/',
					ext: '.jpg',
					details:
					[
						'Alzacristales eléctricos en las 4 puertas',
						'Alarma y cierre centralizado',
						'Display de tablero multifunción de 3,5’’',
					],
				},
				desktop:
				{
					name: 'FREEDOM',
					fullname: 'FIAT STRADA FREEDOM',
					icon: '/assets/images/desktop/360/nav/freedom-dupla.png',
					dirname: '/assets/images/desktop/360/FREEDOM-DUPLA/',
					ext: '.jpg',
					details:
					[
						'Alzacristales eléctricos en las 4 puertas',
						'Alarma y cierre centralizado',
						'Display de tablero multifunción de 3,5’’',
					],
				},
			},
	
		],

		// VOLCANO
		[
			{
				doubleCabin: true,
				mobile:
				{
					name: 'VOLCANO',
					fullname: 'FIAT STRADA VOLCANO',
					icon: '/assets/images/desktop/360/nav/volcano.png',
					dirname: '/assets/images/mobile/360/VOLCANO/',
					ext: '.jpg',
					details:
					[
						'Central multimedia Uconnect de 7” que espeja tu teléfono',
						'Faros LED',
						'Cámara y sensores traseros de estacionamiento',
					],
				},
				desktop:
				{
					name: 'VOLCANO',
					fullname: 'FIAT STRADA VOLCANO',
					icon: '/assets/images/desktop/360/nav/volcano.png',
					dirname: '/assets/images/desktop/360/VOLCANO/',
					ext: '.jpg',
					details:
					[
						'Central multimedia Uconnect de 7” que espeja tu teléfono',
						'Faros LED',
						'Cámara y sensores traseros de estacionamiento',
					],
				},
			},
		],
		// D4B -STRADA VOLCANO 1.3 CVT
		[
			{
				doubleCabin: true,
				mobile:
				{
					name: 'VOLCANO 1.3 CVT',
					fullname: 'FIAT STRADA VOLCANO 1.3 CVT',
					icon: '/assets/images/desktop/360/nav/volcano.png',
					dirname: '/assets/images/mobile/360/VOLCANO/',
					ext: '.jpg',
					details:
					[
						'Central multimedia Uconnect de 7” que espeja tu teléfono',
						'Faros LED',
						'Cámara y sensores traseros de estacionamiento',
					],
				},
				desktop:
				{
					name: 'VOLCANO 1.3 CVT',
					fullname: 'FIAT STRADA VOLCANO 1.3 CVT',
					icon: '/assets/images/desktop/360/nav/volcano.png',
					dirname: '/assets/images/desktop/360/VOLCANO/',
					ext: '.jpg',
					details:
					[
						'Central multimedia Uconnect de 7” que espeja tu teléfono',
						'Faros LED',
						'Cámara y sensores traseros de estacionamiento',
					],
				},
			},
		],

	],
};

export default data;
